var _style, _rect, _defs, _defs2, _defs3, _path, _defs4, _defs5, _path2, _path3, _defs6, _defs7, _defs8, _path4, _defs9, _defs10, _defs11, _path5, _path6, _defs12, _defs13, _defs14, _defs15, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTurtleSvgLogo3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2250 1500",
    style: {
      enableBackground: "new 0 0 2250 1500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:#FFFFFF;}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000021116454262012094480000012393783229280117651_);fill:url(#SVGID_00000109730934612504418260000014863281620342188934_);}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000173840274972075733820000017592237670214589858_);fill:url(#SVGID_00000048476128463227113660000008951061240261663158_);}\n\t\n\t\t.st3{clip-path:url(#SVGID_00000157999297058538486180000007851912997866566801_);fill:url(#SVGID_00000067232204382044652690000016969863012211178154_);}\n\t.st4{opacity:0.13;fill-rule:evenodd;clip-rule:evenodd;fill:#001422;}\n\t\n\t\t.st5{clip-path:url(#SVGID_00000134214082544801454210000007621728734147774368_);fill:url(#SVGID_00000181058666518264040340000013316699007253649830_);}\n\t\n\t\t.st6{clip-path:url(#SVGID_00000126313178334683600910000012273792399741658255_);fill:url(#SVGID_00000047055796589866762710000017472945937710030783_);}\n\t.st7{opacity:0.19;fill-rule:evenodd;clip-rule:evenodd;fill:#070317;}\n\t\n\t\t.st8{clip-path:url(#SVGID_00000059279115427643825730000002631542737577430674_);fill:url(#SVGID_00000119096259504433348000000018274351943350031488_);}\n\t\n\t\t.st9{clip-path:url(#SVGID_00000142159697663359211360000015026634314390013877_);fill:url(#SVGID_00000145043052564259270150000006193105022007705522_);}\n\t\n\t\t.st10{clip-path:url(#SVGID_00000072967031178410113970000008328441815499176123_);fill:url(#SVGID_00000108308055447170010610000006175028306804083899_);}\n\t.st11{opacity:0.28;fill-rule:evenodd;clip-rule:evenodd;fill:#FA9CFF;}\n\t\n\t\t.st12{clip-path:url(#SVGID_00000130633072487631657800000007360274767044883866_);fill:url(#SVGID_00000156560092781170055980000014209021027332776843_);}\n\t\n\t\t.st13{clip-path:url(#SVGID_00000138533536777249591920000003608229381622559919_);fill:url(#SVGID_00000164513388028401509060000008573437713311725457_);}\n\t\n\t\t.st14{clip-path:url(#SVGID_00000021095004094561508930000006301383661627234702_);fill:url(#SVGID_00000124135480972769917840000006870083751562474936_);}\n\t.st15{opacity:0.19;fill-rule:evenodd;clip-rule:evenodd;}\n\t\n\t\t.st16{clip-path:url(#SVGID_00000175310014707360930750000000231902378461685131_);fill:url(#SVGID_00000177460903106153765400000001907658872812621750_);}\n\t\n\t\t.st17{clip-path:url(#SVGID_00000111910060786494480650000004579590570369587343_);fill:url(#SVGID_00000111166770615538905390000007950619708950112429_);}\n\t\n\t\t.st18{clip-path:url(#SVGID_00000111910390700075471830000008744795331228796834_);fill:url(#SVGID_00000013897704615506305980000015285253286331322013_);}\n\t\n\t\t.st19{clip-path:url(#SVGID_00000147204120209805353450000016838230707865121680_);fill:url(#SVGID_00000116949190272331969150000018365533469040762241_);}\n\t.st20{opacity:0.21;fill-rule:evenodd;clip-rule:evenodd;fill:#FEFEFE;}\n\t.st21{opacity:0.21;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st22{opacity:0.36;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st23{display:none;fill:#29ABE2;stroke:#000000;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 2250,
    height: 1500
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M1380.46,745.8c0,0,237.9-134.24,406.4-71.36c0,0,135.82-20.12,181.08-88.02 c0,0-85.5-186.11-286.71-186.11c0,0-57.09,13.62-158.47,77.97l-91.79,58.15L1380.46,745.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000095331712346346827310000013595390621179377079_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179623316518777696770000015522350584132432298_",
    gradientUnits: "userSpaceOnUse",
    x1: 1507.625,
    y1: 600.6689,
    x2: 1979.4602,
    y2: 522.4322
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#901755"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB7228"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1380.46,
    y: 400.3,
    style: {
      clipPath: "url(#SVGID_00000095331712346346827310000013595390621179377079_)",
      fill: "url(#SVGID_00000179623316518777696770000015522350584132432298_)"
    },
    width: 587.48,
    height: 345.5
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000152969882452250717000000015131081311449999522_",
    d: "M1967.94,586.41c0,0-85.5-186.11-286.71-186.11 c0,0-46.02,10.98-128.8,59.8C1625.97,519.13,1757.96,589.36,1967.94,586.41"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000161592807108381594670000005513503078619868819_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152969882452250717000000015131081311449999522_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011713004919857674720000014930333293046571146_",
    gradientUnits: "userSpaceOnUse",
    x1: 1434.3417,
    y1: 578.575,
    x2: 1968.958,
    y2: 441.1775
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#901755"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB7228"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1552.43,
    y: 400.3,
    style: {
      clipPath: "url(#SVGID_00000161592807108381594670000005513503078619868819_)",
      fill: "url(#SVGID_00000011713004919857674720000014930333293046571146_)"
    },
    width: 415.51,
    height: 189.06
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000047755886946032856510000013087725047974229633_",
    d: "M1380.46,745.8c0,0,237.9-134.24,406.4-71.36 c0,0,34.11-5.05,73.84-18.64c0,0-288.03-141.05-456.29,36.89c-5.65,5.98-10.73,11.8-15.35,17.49L1380.46,745.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072257719628655062940000009318236670470481049_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047755886946032856510000013087725047974229633_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168839854877684375550000010727732752310418053_",
    gradientUnits: "userSpaceOnUse",
    x1: 1569.8967,
    y1: 649.5223,
    x2: 1903.6104,
    y2: 522.7498
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#901755"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB7228"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1380.46,
    y: 514.74,
    style: {
      clipPath: "url(#SVGID_00000072257719628655062940000009318236670470481049_)",
      fill: "url(#SVGID_00000168839854877684375550000010727732752310418053_)"
    },
    width: 480.24,
    height: 231.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1380.46,745.8c0,0,81.21-45.81,182.35-71.37c-12.81-108.33-40.05-196.15-40.05-196.15l-91.79,58.15 L1380.46,745.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000155854811038108240550000004647240447517436816_",
    d: "M1522.76,478.27 C985.33,811.52,1002.17,929.24,174.42,871.89C726.12,1269.97,1600.65,1164.37,1522.76,478.27"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150096199781447882070000005975754694877714858_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155854811038108240550000004647240447517436816_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118398820341222596940000014933222902126190725_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.722,
    y1: 1090.2472,
    x2: 1535.521,
    y2: 652.4583
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1B1BA3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#65C7F7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 174.42,
    y: 478.27,
    style: {
      clipPath: "url(#SVGID_00000150096199781447882070000005975754694877714858_)",
      fill: "url(#SVGID_00000118398820341222596940000014933222902126190725_)"
    },
    width: 1426.22,
    height: 791.7
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000053518170782259884990000016002575316022443419_",
    d: "M174.42,871.89 c535.13,386.13,1373.93,298.34,1352.77-333.4C1525.98,545.46,1380.69,1371.97,174.42,871.89"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000097474017051444356640000003490643460376345748_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000053518170782259884990000016002575316022443419_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089568593390243822200000013133657229679207326_",
    gradientUnits: "userSpaceOnUse",
    x1: 559.6735,
    y1: 1057.0557,
    x2: 1548.4991,
    y2: 723.3412
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1B1BA3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#65C7F7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 174.42,
    y: 538.49,
    style: {
      clipPath: "url(#SVGID_00000097474017051444356640000003490643460376345748_)",
      fill: "url(#SVGID_00000089568593390243822200000013133657229679207326_)"
    },
    width: 1373.93,
    height: 833.48
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1427.94,538.37c-42.19,27.31-80.65,52.9-116.43,76.86c-22.3,221.49-185.49,451.53-189.34,456.92 c100.69-27.87,189.44-74.6,258.04-140.69c64.92-178.84,57.78-337.94,57.78-337.94L1427.94,538.37z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M647.1,882.14c-110.68,6.6-246.13,4.16-421.34-6.87c-6.25,6.24-12.45,12.68-18.61,19.3 c73.16,49.08,151.31,89.67,231.72,121.58C528.08,978.19,596.01,930.07,647.1,882.14"
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000170967489180277628000000006718090423347520131_",
    d: "M861.35,1262.95 c558.34-196.17,558.87-611.55,558.87-611.55C1110.4,764,933.44,894.94,861.35,1262.95"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000002373405217182759420000004834069066055197097_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170967489180277628000000006718090423347520131_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163044943077403606480000004987734184085252002_",
    gradientUnits: "userSpaceOnUse",
    x1: 933.4734,
    y1: 1251.6301,
    x2: 1168.4248,
    y2: 917.9166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#901755"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB7228"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 861.35,
    y: 651.4,
    style: {
      clipPath: "url(#SVGID_00000002373405217182759420000004834069066055197097_)",
      fill: "url(#SVGID_00000163044943077403606480000004987734184085252002_)"
    },
    width: 558.87,
    height: 611.55
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000169531183479530587210000018272166116230379438_",
    d: "M1148.34,781.79 c-138.01,93.46-228.54,222.77-278.26,440.14C1006.42,1097,1093.76,928.17,1148.34,781.79"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047780308917231955280000006378864461849399470_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000169531183479530587210000018272166116230379438_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055667770990213035290000015104889453225170621_",
    gradientUnits: "userSpaceOnUse",
    x1: 828.3797,
    y1: 1191.4886,
    x2: 1081.4417,
    y2: 926.1111
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#901755"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB7228"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 870.08,
    y: 781.79,
    style: {
      clipPath: "url(#SVGID_00000047780308917231955280000006378864461849399470_)",
      fill: "url(#SVGID_00000055667770990213035290000015104889453225170621_)"
    },
    width: 278.26,
    height: 440.14
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000044856412304406573100000009996280602954659467_",
    d: "M970.24,1218.84 c449.43-208.06,449.98-567.43,449.98-567.43c-5.42,1.97-10.8,3.94-16.13,5.93C1193.61,837.09,1049.38,1068.84,970.24,1218.84"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165198054047534127780000003105023831723915435_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044856412304406573100000009996280602954659467_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071528360164538192960000002979347590870616766_",
    gradientUnits: "userSpaceOnUse",
    x1: 1004.2675,
    y1: 1156.0371,
    x2: 1242.8418,
    y2: 880.035
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#901755"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB7228"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 970.24,
    y: 651.4,
    style: {
      clipPath: "url(#SVGID_00000165198054047534127780000003105023831723915435_)",
      fill: "url(#SVGID_00000071528360164538192960000002979347590870616766_)"
    },
    width: 449.98,
    height: 567.43
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M861.35,1262.95c558.34-196.17,558.87-611.55,558.87-611.55c-15.48,5.63-30.6,11.29-45.41,17.04 c-2.19,6.62-4.26,13.3-6.08,20.12c-94.79,355.62-485.46,485.52-486.79,485.97C874.32,1202.4,867.45,1231.81,861.35,1262.95"
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000168079562094560098750000002519345650415845285_",
    d: "M69.56,1090.46c590.07-44.98,698.1-446.07,698.1-446.07 C439.27,672.97,234.44,753.65,69.56,1090.46"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132071784579685224520000004307678541423230863_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168079562094560098750000002519345650415845285_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121997434744664121960000004323829557366783374_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.0597,
    y1: 1098.1713,
    x2: 455.4898,
    y2: 836.6575
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#901755"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB7228"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 69.56,
    y: 644.39,
    style: {
      clipPath: "url(#SVGID_00000132071784579685224520000004307678541423230863_)",
      fill: "url(#SVGID_00000121997434744664121960000004323829557366783374_)"
    },
    width: 698.1,
    height: 446.07
  })), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000113311480133238121880000005231681784443849091_",
    d: "M471.31,699.97C313.8,754.53,192.89,856,88.6,1053.09 C252.64,967.71,380.69,827.24,471.31,699.97"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181803004971208144140000004117521978924577455_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000113311480133238121880000005231681784443849091_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032645294284504336340000017966042349721485970_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.0405,
    y1: 1012.9203,
    x2: 369.2294,
    y2: 822.1577
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#901755"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB7228"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 88.6,
    y: 699.97,
    style: {
      clipPath: "url(#SVGID_00000181803004971208144140000004117521978924577455_)",
      fill: "url(#SVGID_00000032645294284504336340000017966042349721485970_)"
    },
    width: 382.7,
    height: 353.12
  })), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000017507756660655181730000000050486279401789615_",
    d: "M186.16,1076.03 c487.96-84.66,581.51-431.64,581.51-431.64c-5.74,0.5-11.45,1.02-17.11,1.56C500.72,765.11,301.42,951.63,186.16,1076.03"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000097475659711697594070000000356230797786168721_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000017507756660655181730000000050486279401789615_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045595797954553677810000011084883594680128649_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.2516,
    y1: 1024.1538,
    x2: 537.0911,
    y2: 819.3857
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#901755"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB7228"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 186.16,
    y: 644.39,
    style: {
      clipPath: "url(#SVGID_00000097475659711697594070000000356230797786168721_)",
      fill: "url(#SVGID_00000045595797954553677810000011084883594680128649_)"
    },
    width: 581.51,
    height: 431.64
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M69.56,1090.46c590.08-44.98,698.1-446.07,698.1-446.07c-16.4,1.43-32.48,2.99-48.27,4.7 c-3.83,5.83-7.56,11.75-11.08,17.87c-183.61,318.97-594.58,343.32-595.98,343.41C97.75,1035.33,83.52,1061.95,69.56,1090.46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1522.76,478.27C985.33,811.52,1002.17,929.24,174.42,871.89c5.74,4.14,11.57,8.15,17.38,12.18 c283.71,72.01,1115.1,232.88,1334.77-285.53C1528.72,560.64,1527.56,520.57,1522.76,478.27"
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000073700594327313352340000009414417171864091324_",
    d: "M59.03,840.44c0,0,1285.17,407.43,1463.73-362.17 C987.55-94.21,496.37,487.47,59.03,840.44"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000172428929857381240490000016541340869345597369_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000073700594327313352340000009414417171864091324_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101087174255519942770000009542790958022482620_",
    gradientUnits: "userSpaceOnUse",
    x1: 1492.6765,
    y1: 399.8376,
    x2: 40.2254,
    y2: 766.1506
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7BFBD4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEFEFE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 59.03,
    y: -94.21,
    style: {
      clipPath: "url(#SVGID_00000172428929857381240490000016541340869345597369_)",
      fill: "url(#SVGID_00000101087174255519942770000009542790958022482620_)"
    },
    width: 1463.73,
    height: 1342.07
  })), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000029765789383646485520000011129236752244212921_",
    d: "M59.03,840.43c0,0,1259.48,344.63,1412.36-367.87 C936.17-99.92,496.37,487.47,59.03,840.43"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176759549518005033870000013791657746350649769_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029765789383646485520000011129236752244212921_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139293973072859329670000012683163694880285341_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.5086,
    y1: 716.0594,
    x2: 1268.187,
    y2: 423.1545
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E93CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5FFBDE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 59.03,
    y: -99.92,
    style: {
      clipPath: "url(#SVGID_00000176759549518005033870000013791657746350649769_)",
      fill: "url(#SVGID_00000139293973072859329670000012683163694880285341_)"
    },
    width: 1412.36,
    height: 1284.98
  })), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000024720366017637841210000017067137826298607749_",
    d: "M59.03,840.43c0,0,1103.69,301.96,1370.08-243.99 c-321.41-205.32-668.94-192.21-978.69-94.86C318.13,610.97,188.47,735.97,59.03,840.43"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147942260372279490010000005132552044598990000_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000024720366017637841210000017067137826298607749_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179629007014903466210000013761302597831044276_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.0275,
    y1: 909.3948,
    x2: 1255.2539,
    y2: 560.2264
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E93CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5FFBDE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 59.03,
    y: 391.12,
    style: {
      clipPath: "url(#SVGID_00000147942260372279490010000005132552044598990000_)",
      fill: "url(#SVGID_00000179629007014903466210000013761302597831044276_)"
    },
    width: 1370.08,
    height: 751.27
  })), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000160886389071975906580000010552948892556646036_",
    d: "M59.03,840.43c0,0,1259.48,344.63,1412.36-367.87 c-28.04-29.99-55.81-56.62-83.34-80.45C1126.5,893.95,59.03,840.43,59.03,840.43"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091731302667341766600000001974099803174731446_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160886389071975906580000010552948892556646036_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129892843384861124400000002538364706706767247_",
    gradientUnits: "userSpaceOnUse",
    x1: 479.7265,
    y1: 965.8739,
    x2: 1424.6051,
    y2: 379.097
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E93CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5FFBDE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 59.03,
    y: 392.11,
    style: {
      clipPath: "url(#SVGID_00000091731302667341766600000001974099803174731446_)",
      fill: "url(#SVGID_00000129892843384861124400000002538364706706767247_)"
    },
    width: 1412.36,
    height: 792.95
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M59.03,840.43c0,0,64.4,17.59,165.66,36.61C461.34,652.18,831.39,367.2,1245.54,293.21 C809.4,64.73,433.3,538.37,59.03,840.43"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1615.35,426.33c67.44,46.46,199.05,123.94,336.91,132.29c-32.88-51.88-118.87-158.32-271.03-158.32 C1681.23,400.3,1658.18,405.8,1615.35,426.33"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M671.85,403.84c-58.92,140.42,43.25,77.75,216.94,41.39c173.69-36.37,196.6-63.21,309.52,0.5 c112.93,63.72,294.18,110.81,217.11,8.06c-77.07-102.76-168.55-152.53-231.2-176.97C1053.58,225.86,730.78,263.42,671.85,403.84"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M860.33,338.55c-35.3,77.94,23.07,44.35,121.19,26.66c98.12-17.69,111.41-32.4,173.83,5.16 c62.43,37.56,163.48,66.87,121.81,7.95c-41.67-58.93-92.26-88.33-127.06-103.04C1077.53,244.61,895.63,260.62,860.33,338.55"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2181.32,1361.86v-29.74h-82.5v-31.92h71.65v-29.75h-71.65v-30.83h81.42v-29.74h-114.42v151.98H2181.32z  M2040.63,1361.86v-30.18h-75.77v-121.8h-33.44v151.98H2040.63z M1905.81,1240.71v-30.83h-125.92v30.83h46.24v121.15h33.43v-121.15 H1905.81z M1726.69,1262.21c0,6.51-2.21,11.72-6.62,15.63c-4.41,3.91-10.75,5.86-19,5.86h-33.87v-43.64h33.22 c8.25,0,14.69,1.81,19.32,5.43c4.63,3.62,6.95,9.05,6.95,16.29V1262.21z M1765.12,1361.86l-37.13-54.28 c9.7-3.62,17.55-9.3,23.56-17.04c6.01-7.74,9.01-17.77,9.01-30.07v-0.44c0-15.77-5.03-28.08-15.09-36.91 c-10.06-8.83-24.14-13.24-42.23-13.24h-69.47v151.98h33.44v-48.63h26.27l32.57,48.63H1765.12z M1599.68,1295.64v-85.76h-33.44v87.06 c0,12.16-2.89,21.28-8.69,27.36c-5.79,6.08-13.82,9.12-24.1,9.12c-10.27,0-18.31-3.15-24.1-9.44c-5.79-6.3-8.69-15.67-8.69-28.12 v-85.98h-33.43v86.84c0,22.44,5.86,39.3,17.59,50.59c11.72,11.29,27.79,16.93,48.2,16.93c10.13,0,19.32-1.41,27.57-4.23 c8.25-2.82,15.27-7.09,21.06-12.81s10.24-12.84,13.35-21.39C1598.12,1317.28,1599.68,1307.22,1599.68,1295.64z M2044.44,1426.15 v-8.12h-22.51v-8.71h19.55v-8.12h-19.55v-8.41h22.21v-8.12h-31.22v41.47H2044.44z M1949.64,1426.15v-41.47h-9v25.53l-19.43-25.53 h-8.41v41.47h9.01v-26.36l20.08,26.36H1949.64z M1849.1,1426.15v-41.47h-9.12v41.47H1849.1z M1779.35,1426.15v-8.23h-20.67v-33.23 h-9.12v41.47H1779.35z M1687.45,1420.28v-18.01h-18.01v7.88h9.18v5.96c-2.33,1.67-5.2,2.51-8.59,2.51c-1.86,0-3.54-0.33-5.06-0.98 c-1.52-0.65-2.84-1.58-3.97-2.76c-1.13-1.18-2-2.58-2.61-4.19c-0.61-1.6-0.92-3.36-0.92-5.25v-0.12c0-1.78,0.3-3.46,0.92-5.02 c0.61-1.57,1.46-2.93,2.55-4.1c1.09-1.16,2.35-2.1,3.79-2.79c1.44-0.69,2.99-1.04,4.65-1.04c1.18,0,2.27,0.1,3.26,0.3 c0.99,0.2,1.91,0.47,2.76,0.83c0.85,0.36,1.67,0.79,2.46,1.3c0.79,0.51,1.58,1.11,2.37,1.78l5.75-6.93 c-1.07-0.91-2.17-1.72-3.32-2.43c-1.15-0.71-2.37-1.3-3.67-1.78c-1.3-0.47-2.72-0.84-4.23-1.1c-1.52-0.26-3.21-0.38-5.07-0.38 c-3.16,0-6.06,0.56-8.71,1.69c-2.65,1.13-4.94,2.67-6.87,4.62c-1.94,1.96-3.45,4.23-4.53,6.81c-1.09,2.59-1.63,5.36-1.63,8.32v0.12 c0,3.08,0.53,5.92,1.6,8.53c1.07,2.61,2.56,4.86,4.47,6.75c1.92,1.89,4.21,3.38,6.87,4.44c2.66,1.07,5.62,1.6,8.86,1.6 c3.79,0,7.16-0.64,10.1-1.93C1682.78,1423.65,1685.32,1422.1,1687.45,1420.28z M1573.46,1408.79h-11.02l5.51-13.45L1573.46,1408.79z  M1590.04,1426.15l-17.77-41.76h-8.41l-17.77,41.76h9.3l3.79-9.3h17.54l3.79,9.3H1590.04z M1489.32,1393.1v-8.41h-34.36v8.41h12.62 v33.05h9.12v-33.05H1489.32z M1444.01,1240.71v-30.83h-125.92v30.83h46.24v121.15h33.43v-121.15H1444.01z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurtleSvgLogo3);
export default __webpack_public_path__ + "static/media/turtle-svg-logo-3.d32bbd8187b2cf5e48b568afde94e59b.svg";
export { ForwardRef as ReactComponent };